// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulk_mainDialog__yrwiu {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  min-width: 980px;
}
.bulk_mainDialog__yrwiu .bulk_header__AfQUe {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bulk_mainDialog__yrwiu .bulk_rowItem__FfAWt {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.bulk_mainDialog__yrwiu .bulk_errorContainer__zSua2 {
  width: 100%;
  border-left: 1px solid #eaeaea;
}`, "",{"version":3,"sources":["webpack://./src/components/UserManagement/Add/Result/bulk.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACR;AAEI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAAR;AAGI;EACI,WAAA;EACA,8BAAA;AADR","sourcesContent":[".mainDialog {\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    min-width: 980px;\n\n    .header {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .rowItem {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n    }\n\n    .errorContainer {\n        width: 100%;\n        border-left: 1px solid #eaeaea;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainDialog": `bulk_mainDialog__yrwiu`,
	"header": `bulk_header__AfQUe`,
	"rowItem": `bulk_rowItem__FfAWt`,
	"errorContainer": `bulk_errorContainer__zSua2`
};
export default ___CSS_LOADER_EXPORT___;
